module.exports = __webpack_public_path__ + "static/confusing-words-a4a36d61aa04983fd720fd96acc8f334.jpg";